export default [
  [
    { text: 'Можно с детьми', model: 'childrenAllowed' },
    { text: 'Можно с животными', model: 'petsAllowed' },
    { text: 'Холодильник', model: 'hasFridge' },
    { text: 'Посудомоечная машина', model: 'hasDishwasher' },
    { text: 'Стиральная машина', model: 'hasWasher' },
    { text: 'Мебель в комнатах', model: 'hasFurniture' },
    { text: 'Мебель на кухне', model: 'hasKitchenFurniture' },
    { text: 'Кондиционер', model: 'hasConditioner' },
  ],
  [
    { text: 'Телевизор', model: 'hasTv' },
    { text: 'Интернет', model: 'hasInternet' },
    { text: 'Телефон', model: 'hasPhone' },
    { text: 'Ванна', model: 'hasBathtub' },
    { text: 'Душевая кабина', model: 'hasShower' },
    { text: 'Баня', model: 'hasBathhouse' },
    { text: 'Гараж', model: 'hasGarage' },
    { text: 'Бассейн', model: 'hasPool' },
  ],
];
